import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore, CollectionReference, Query } from '@angular/fire/compat/firestore';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { map, Observable, of } from 'rxjs';

import { Collection } from '../resources/app-firebase';
import { BookmarkProblemsCollection } from '../models/bookmark-problem';

@Injectable({
  providedIn: 'root'
})
export class BookmarkProblemsService {
  constructor(private afAuth: AngularFireAuth, private afs: AngularFirestore, private aff: AngularFireFunctions) {}

  findBookmarkProblems(userId: string, subjectIds: string[]): Observable<BookmarkProblemsCollection[]> {
    // subjectIdsが空の場合、リストを取得できないため、空配列を返却
    if (!subjectIds || subjectIds.length === 0) {
      return of([]);
    }

    return this.afs
      .collection<BookmarkProblemsCollection>(Collection.BOOKMARK_PROBLEMS, ref => {
        let query: CollectionReference | Query = ref;
        query = query.where('userId', '==', userId).where('subjectId', 'in', subjectIds);
        return query;
      })
      .get()
      .pipe(
        map(snapshot => {
          return snapshot.empty
            ? []
            : snapshot.docs.map(doc => {
                const bookmarkProblemId: string = doc.id;
                const data = doc.data();
                data.id = bookmarkProblemId;
                return data as BookmarkProblemsCollection;
              });
        })
      );
  }
}
